import { __ } from '@wordpress/i18n'

function NewArrival() {
  return (
    <span className="mb-1 block text-xs uppercase italic">
      {__('New arrivals', 'asavagroup')}
    </span>
  )
}

export default NewArrival
